import React, { useEffect, useState } from 'react';
import { createLevelMeter, MEDIA_ERRORS, useStreamVideo } from '../aiinterview/media';
import { LevelBar } from '../aiinterview/LevelBar';

// Camera + mic check shown before joining; the caller stops the preview stream on join.
export default function PreJoin({ media, children }) {
  const [, setVideo] = useStreamVideo(media.stream);
  const [meter, setMeter] = useState(null);
  const [micOk, setMicOk] = useState(false);
  useEffect(() => { media.ensure().catch(() => {}); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!media.stream) return undefined;
    const m = createLevelMeter(media.stream);
    setMeter(m);
    const t = setInterval(() => { if (m.read() > 0.03) setMicOk(true); }, 120);
    return () => { clearInterval(t); m.close(); setMeter(null); };
  }, [media.stream]);
  const cam = media.stream?.getVideoTracks()[0];
  return (
    <div className="vr-prejoin" data-testid="prejoin">
      {media.error ? (
        <div className="iv-note is-bad" data-testid="prejoin-media-error">
          {MEDIA_ERRORS[media.error]}
          <div style={{ marginTop: '0.6rem' }}><button type="button" className="iv-btn iv-btn-ghost iv-btn-sm" onClick={() => media.ensure().catch(() => {})} data-testid="prejoin-retry-btn">Try again</button></div>
        </div>
      ) : (
        <div className="iv-video">
          <video ref={setVideo} className="is-mirror" autoPlay muted playsInline data-testid="prejoin-camera-preview" />
          <span className="iv-video-tag">{cam?.readyState === 'live' ? 'Camera ready' : 'Starting camera…'}</span>
        </div>
      )}
      <div style={{ marginTop: '0.9rem' }}>
        <div className="iv-row" style={{ justifyContent: 'space-between', marginBottom: '0.35rem' }}>
          <span className="vr-muted">Microphone</span>
          <span className={`iv-pill iv-tone-${micOk ? 'green' : 'amber'}`} data-testid="prejoin-mic-status">{micOk ? 'We can hear you' : 'Say something…'}</span>
        </div>
        <LevelBar meter={meter} testId="prejoin-mic-meter" />
      </div>
      {children}
    </div>
  );
}
